enum AIReviewDotRating {
    Bad = -1,
    Good = 1
}

export function getAIReviewDotRatingFromString(rating: string): AIReviewDotRating {
    switch (rating) {
        case "-1":
            return AIReviewDotRating.Bad;
        case "1":
        default:
            return AIReviewDotRating.Good;
    }
}

export default AIReviewDotRating;
